export default function scrollToTop(ref: any) {
  if (ref && ref.current) {
    ref.current.scrollTo({ top: 0 });
  }
}
